import { Decimal } from 'decimal.js';
import { getUnitConversionFactor, sanitizeUnit } from './calculations.js';
// Converts stored amounts between units using the shared unit registry; identical units pass unchanged, anything else throws so an amount is never taken 1:1
export function convertAmountToUnit({ amount, from, to }) {
    if (!from || !to)
        throw new Error(`Cannot convert an amount without a unit (from "${from}" to "${to}").`);
    const value = new Decimal(amount);
    if (!value.isFinite())
        throw new Error(`Cannot convert the amount ${String(amount)} ${from} to ${to}.`);
    if (sanitizeUnit(from) === sanitizeUnit(to))
        return value;
    return value.mul(getUnitConversionFactor(from, to));
}
//# sourceMappingURL=mass-units.js.map